import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-backend-down',
  standalone: true,
  imports: [],
  templateUrl: './backend-down.component.html',
  styleUrls: ['./backend-down.component.css']
})
export class BackendDownComponent {
  constructor(private router: Router) {}

  retry(): void {
    // Clear any stored errors and try to go back to home
    window.location.href = '/';
  }
}
